@if (bestDeals$ | async; as bestDeals) {
  <div class="overflow-hidden carousel-wrapper">
    <div class="max-mobile-view m-a">
      <div class="px-4 py-2">
        <cui-carousel
          *hasCompanyClientUISettingsDisabled="showOnlyBestDealInComparisonResultsKey"
          [itemsLength]="bestDeals?.length"
          arrowButtonStyleClass="fill">
          @for (item of bestDeals; track item; let idx = $index) {
            <div class="mx-2 fill-light">
              <cp-ticket-container
                [labelIcon]="BEST_DEAL_ICON_LABEL[item.flag]?.icon"
                [label]="BEST_DEAL_ICON_LABEL[item.flag]?.label"
                [image]="item.lenderLogo"
                valueLabel="PAYMENTS"
                [value]="item.initialRatePayment" />
            </div>
          }
        </cui-carousel>
        <cp-ticket-container
          *hasCompanyClientUiSettingsEnabled="showOnlyBestDealInComparisonResultsKey"
          [value]="bestDeals[0].initialRatePayment"
          [image]="bestDeals[0].lenderLogo"
          valueLabel="PAYMENTS" />
      </div>
    </div>
  </div>
}
